import React from 'react';
import './App.css';
import GridEditor from './components/GridEditor';

function App() {
  return (
    <div className="App">
      <GridEditor />
    </div>
  );
}

export default App;
